import Client from "fhir-kit-client";
import { AuditEvent } from "fhir/r5";

var fhirClient = new Client({
  baseUrl: process.env.REACT_APP_FHIR_URL_AUDIT ?? "fhir",
});

export const changeServer = (serverUrl: string) =>  {
  fhirClient = new Client({
    baseUrl: serverUrl,
  });
}

export const getAuditEventById = async (id: string) => {
  console.log (fhirClient.baseUrl)
  return (await fhirClient.read({
    resourceType: "AuditEvent",
    id: id,
  })) as AuditEvent;
};